// extracted by mini-css-extract-plugin
export default {"container":"NewsThumbEditor_container__nb+zB","converPlaceholder":"NewsThumbEditor_converPlaceholder__BNWCL","thumbImg":"NewsThumbEditor_thumbImg__JLnkn"};